import { apiLabs } from '../../api'


const postEggsShell = async (body) => {
	const res = await apiLabs.post('separa/painel_cascas', body)

	return res
}

export default postEggsShell
